// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-70bd713f]{align-items:center;display:flex}.title h1[data-v-70bd713f]{margin:0}header[data-v-70bd713f]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
